module.exports = __webpack_public_path__ + "static/media/kasama.c41937cf.webp";